/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Claim_Your_Free_StorefrontInputs */

const en_claim_your_free_storefront = /** @type {(inputs: Claim_Your_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claim Your Free Storefront`)
};

const es_claim_your_free_storefront = /** @type {(inputs: Claim_Your_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reclama tu tienda gratuita`)
};

const fr_claim_your_free_storefront = /** @type {(inputs: Claim_Your_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réclamez votre vitrine gratuite`)
};

const de_claim_your_free_storefront = /** @type {(inputs: Claim_Your_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hol dir deine kostenlose Storefront`)
};

const ja_claim_your_free_storefront = /** @type {(inputs: Claim_Your_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料ストアフロントを取得する`)
};

const zh_claim_your_free_storefront = /** @type {(inputs: Claim_Your_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`认领您的免费店铺`)
};

const ar_claim_your_free_storefront = /** @type {(inputs: Claim_Your_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احصل على واجهة متجرك المجانية`)
};

const id_claim_your_free_storefront = /** @type {(inputs: Claim_Your_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klaim Etalase Gratis Anda`)
};

const it_claim_your_free_storefront = /** @type {(inputs: Claim_Your_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Richiedi la Tua Vetrina Gratuita`)
};

const ru_claim_your_free_storefront = /** @type {(inputs: Claim_Your_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Получите свою бесплатную витрину`)
};

const pt_claim_your_free_storefront = /** @type {(inputs: Claim_Your_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reivindique a sua Vitrine Grátis`)
};

const ko_claim_your_free_storefront = /** @type {(inputs: Claim_Your_Free_StorefrontInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`무료 스토어프론트 신청하기`)
};

/**
* | output |
* | --- |
* | "Claim Your Free Storefront" |
*
* @param {Claim_Your_Free_StorefrontInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const claim_your_free_storefront = /** @type {((inputs?: Claim_Your_Free_StorefrontInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Claim_Your_Free_StorefrontInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_claim_your_free_storefront(inputs)
	if (locale === "es") return es_claim_your_free_storefront(inputs)
	if (locale === "fr") return fr_claim_your_free_storefront(inputs)
	if (locale === "de") return de_claim_your_free_storefront(inputs)
	if (locale === "ja") return ja_claim_your_free_storefront(inputs)
	if (locale === "zh") return zh_claim_your_free_storefront(inputs)
	if (locale === "ar") return ar_claim_your_free_storefront(inputs)
	if (locale === "id") return id_claim_your_free_storefront(inputs)
	if (locale === "it") return it_claim_your_free_storefront(inputs)
	if (locale === "ru") return ru_claim_your_free_storefront(inputs)
	if (locale === "pt") return pt_claim_your_free_storefront(inputs)
	return ko_claim_your_free_storefront(inputs)
});